
let Common = require("./../common").Common;
let parse = require("./../cr-agreement/parse").parse;
let package_inner = require('./../cr-agreement/assemble').package_inner;



var TOP = "02", END = "03"; // 内容头尾

var mqtt_ack_request = 0,   // MQTT请求
    mqtt_ack_response = 1;  // MQTT响应

var mqtt_encrypt_not = 0,   //  MQTT不加密
    mqtt_encrypt_aes = 1;   //  MQTT AES加密

var mqtt_confirm_nwait = 0,      // 发送期待应答
    mqtt_confirm_wait = 1,     // 发送不期待应带
    mqtt_confirm_success = 2,   // 应答成功
    mqtt_confirm_fail = 3;      // 应答失败

var mqtt_cd_module = 0,     // 模块命令
    mqtt_cd_cmd = 1,        // 服务器命令
    mqtt_cd_data = 2,       // 服务器数据流
    mqtt_cd_api = 3;        // API数据流

var mqtt_qos_0 = 0,
    mqtt_qos_1 = 1;

var mqtt_processor_innner = 0,      // MQTT协议处理器 前端处理内容部分
    mqtt_proccessor_web_all = 1,    //  MQTT协议处理器 前端处理全部
    mqtt_processor_server_all = 2;  // MQTT协议处理器 服务器处理全部

var X0160_lbsloc = "0:0160", // 获取定位信息
    X0161_siminfo = "0:0161", // 获取Sim卡信息

    X0140_real_report = "1:0140",// 实时汇报
    X0400_sensor = "1:0400",//传感器信息

    API_DATA = "3:";// 数据参数

/**
 * 通用协议内容
 * @type {{base_modulereqa: (function(*): string), base_modulereqp: (function(*): {})}}
 */
var inner_base = {
    /**
     * 模块指令
     */
    MODULE: {
        cd: mqtt_cd_module,
        lbsloc: {
            command: X0160_lbsloc,
            request: function (imqtt, encoding) {
                return "6001";
            },
            response: function (param, encoding) {
                let cmd = Common.pbit2(param, false);
                let lng = Common.pSPF(param).val;
                let lat = Common.pSPF(param).val;
                let rssis = Common.pbit1(param, true).val;
                return {
                    cmd: cmd,
                    lng: lng,
                    lat: lat,
                    rssis: rssis
                };
            }
        },
        siminfo: {
            command: X0161_siminfo,
            request: function (imqtt, encoding) {
                return "6101";
            },
            response: function (param, encoding) {
                let cmd = Common.pbit2(param, false);
                let id = Common.pbit1(param, true).val;
                let status = Common.pbit1Ascii(param).val;
                let iccid = Common.pTxt(param, encoding).val;
                let imsi = Common.pTxt(param, encoding).val;
                return {
                    cmd: cmd,
                    id: id,
                    status: status,
                    iccid: iccid,
                    imsi: imsi,
                };
            }
        }
    },

    /**
     * 命令指令
     */
    CMD: {
        cd: mqtt_cd_cmd,
        real_report: {
            command: X0140_real_report,
            request: function (imqtts, encoding) {
                return "4001" +
                    Common.abit2(imqtts.report_type) +
                    Common.abit2(imqtts.report_cycle) +
                    Common.abit2(imqtts.report_invalid);
            },
            response: function (param, encoding) {
                param = Common.pbit2(param);
                var command = param.val;

                param = Common.pbit2(param, true);
                var report_type = param.val;

                param = Common.pbit1Ascii(param);
                var report_sign = param.val;

                param = Common.pbit1(param, true);
                var detail = param.val;

                param = Common.pbit1(param, true);
                var unit = param.val;

                param = Common.pbin2(param, 4, 16);
                var flag = param.val;

                var weight, tare, unitPrice, totalPrice, singleWeight, pieceCount;
                switch (detail) {
                    case 0:
                        param = Common.pSPF(param);
                        weight = param.val;
                        break;
                    case 1:
                        param = Common.pSPF(param);
                        weight = param.val;

                        param = Common.pSPF(param);
                        tare = param.val;
                        break;
                    case 2:
                        param = Common.pSPF(param);
                        weight = param.val;

                        param = Common.pSPF(param);
                        unitPrice = param.val;

                        param = Common.pSPF(param);
                        totalPrice = param.val;
                        break;
                    case 3:
                        param = Common.pSPF(param);
                        weight = param.val;

                        param = Common.pSPF(param);
                        tare = param.val;

                        param = Common.pSPF(param);
                        unitPrice = param.val;

                        param = Common.pSPF(param);
                        totalPrice = param.val;
                        break;
                    case 4:
                        param = Common.pSPF(param);
                        weight = param.val;

                        param = Common.pSPF(param);
                        singleWeight = param.val;

                        param = Common.pSPF(param);
                        pieceCount = param.val;
                        break;
                    case 5:
                        param = Common.pSPF(param);
                        weight = param.val;

                        param = Common.pSPF(param);
                        tare = param.val;

                        param = Common.pSPF(param);
                        singleWeight = param.val;

                        param = Common.pSPF(param);
                        pieceCount = param.val;
                        break;
                }
                return {
                    report_type: report_type,
                    report_sign: report_sign,
                    detail: detail,
                    unit: unit,
                    flag: flag,
                    weight: weight,
                    tare: tare,
                    unitPrice: unitPrice,
                    totalPrice: totalPrice,
                    singleWeight: singleWeight,
                    pieceCount: pieceCount,
                };
            }
        },
        truck_sensor: {
            command: X0400_sensor,
            request: function (imqtts, encoding) {
                var sensor_index = "";
                for (var i = 0; i < 16; i++) {
                    if (imqtts && imqtts.includes(i)) {
                        sensor_index += '1';
                    } else {
                        sensor_index += '0';
                    }
                }
                return "0004" + Common.abin(sensor_index, 4);
            },
            response: function (param, encoding) {
                param = Common.pbit2(param);
                var command = param.val;

                param = Common.pbit1(param, true);
                var size = param.val;

                var sensors = [];
                for (var i = 0; i < size; i++) {
                    param = Common.pbit1(param, true);
                    var index = param.val;

                    param = Common.pbit1(param, true)
                    var address = param.val;

                    param = Common.pbit4Hex(param)
                    var inner = param.val;

                    param = Common.pbit4Hex(param)
                    var coefficient = param.val;

                    sensors.push({
                        index: index,
                        address: address,
                        inner: inner,
                        coefficient: coefficient,
                    });
                }
                return sensors;
            }
        },
    },

    /**
     * API流
     */
    API: {
        cd: mqtt_cd_api,
        data: {
            command: API_DATA,
            request: function (part, encoding) {
                return package_inner(part);
            },
            response: function (param, encoding) {
                return param.request ? parse(param.data, encoding, false) : {state: param.data};
            }
        },
    }
};

/**
 * cd(0|1|3) + request(request|false) + part(obj|string) 协议组装解析
 */
var map;
var local_instruct_map = function () {
//   debugger
        if (!map) {
            map = new Map();
            for (let key1 in inner_base) {
                var base_cd = inner_base[key1].cd;
                for (let key2 in inner_base[key1]) {
                    if (key2 == "cd") continue;
                    var base_command = inner_base[key1][key2].command;
                    map.set(base_cd + "-" + base_command, inner_base[key1][key2]);
                }
            }
        }

  },
    execute_request = function (cd, request, command, part, encoding) {
        if (!map) local_instruct_map();
        return map.get(cd + "-" + command).request(part, encoding)
    },
    execute_response = function (cd, request, command, part, encoding) {
//   debugger
        if (!map) local_instruct_map();
        return map.get(cd + "-" + command).response({data: part, val: "", request: request});
    };


/**
 * 公共工具类
 * @type {{int2Hex: (function(*): string), int2Bit2: (function(*): string), bit2Hex: (function(*=): string)}}
 */
var common_tool = {
    // int2Hex
    int2Hex: function (int) {
        var hex = int.toString(16);
        return hex.length % 2 == 0 ? hex : ("0" + hex);
    },
    // int2Hex 4长度
    int2Hex4: function (int) {
        var hex = int.toString(16);
        var insert = 4 - hex.length;
        for (var i = 0; i < insert; i++) {
            hex = "0" + hex;
        }
        return hex;
    },
    // int2bit 2个长度
    int2Bit2: function (int) {
        var bit = int.toString(2);
        return bit.length != 2 ? ("0" + bit) : bit;
    },
    // bit2Hex
    bit2Hex: function (bit) {
        var hex = parseInt(bit, 2).toString(16);
        return hex.length % 2 == 0 ? hex : ("0" + hex);
    },
    // hex2bit 8个长度
    hex2Bit8: function (hex) {
        var bit = parseInt(hex, 16).toString(2);
        var insert = 8 - bit.length;
        for (var i = 0; i < insert; i++) {
            bit = "0" + bit;
        }
        return bit;
    },
};

module.exports = {
  execute_response: execute_response,
  execute_request:execute_request,
};



//////////////////
// WEBPACK FOOTER
// ./api/agreement/mqtt-agreement/mqtt_instruct.js
// module id = 4fki
// module chunks = 28